export default class SUBNAV {
  
  constructor(){
    document.addEventListener('DOMContentLoaded', this.init );
  }

  init() {
    // gnav indicator
    $('header .gnav__item').each( function(){
      const $indicator = $(`<button class="gnav__item__indicator btn btn-text">`)
      if( this.querySelectorAll('.subgnav').length ) {
        $(this).append( $indicator )
      }
      $(this).find('.subgnav').slideUp();
      $indicator.on('click', ()=>{
        $(this).find('.subgnav').slideToggle()
        $indicator.toggleClass('is-active')
      });
    });

  }
}